module.exports = __webpack_public_path__ + "static/media/chippers.8ce83e3b.mp4";